// extracted by mini-css-extract-plugin
export var backupIcon = "_mw-1";
export var image = "_mw-0";